import {
  ChangeDetectionStrategy,
  Component,
  Input,
} from '@angular/core';
import {CommonModule} from '@angular/common';
import {KpiCardData} from '../../models/kpi-card-data.model';

@Component({
  selector: 'bo-kpi-card',
  templateUrl: './kpi-card.component.html',
  styleUrls: ['./kpi-card.component.scss'],
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [CommonModule]
})
export class KpiCardComponent {
  @Input({required: true}) data!: KpiCardData;
}

